import { VerifyEmailScreen } from '@/features/auth/VerifyEmailScreen';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/verify-email')({
  staticData: { public: true },
  validateSearch: z.object({ token: z.string().optional() }),
  component: VerifyEmailScreen,
});
